<h2 mat-dialog-title>Muokkaa tiimikokonaisuutta</h2>
<mat-dialog-content>
  <form novalidate>
    <mat-form-field style="width: 100%">
      <mat-label>Nimi</mat-label>
      <input matInput [formField]="lomake.nimi" />
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <mat-label>Voimassa alkaen</mat-label>
      <input matInput [matDatepicker]="dpAlku" [formField]="lomake.alku" />
      <mat-datepicker-toggle matSuffix [for]="dpAlku"></mat-datepicker-toggle>
      <mat-datepicker #dpAlku></mat-datepicker>
      <mat-hint>Tyhjä = ei tiedossa / voimassa aikojen alusta saakka</mat-hint>
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <mat-label>Voimassa päättyen</mat-label>
      <input matInput [matDatepicker]="dpLoppu" [formField]="lomake.loppu" />
      <mat-datepicker-toggle matSuffix [for]="dpLoppu"></mat-datepicker-toggle>
      <mat-datepicker #dpLoppu></mat-datepicker>
      <mat-hint>Tyhjä = voimassa toistaiseksi</mat-hint>
    </mat-form-field>
  </form>
  @if (virhe) {
    <div class="red-text" style="margin-top: 8px">{{ virhe }}</div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <app-secondary-button style="margin-right: 10px" (click)="peruuta()" actionId="Peruuta">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Tallenna tiimikokonaisuuden tiedot" [actionContext]="[data.kokonaisuusAvain, lomake.nimi().value(), lomake.alku().value(), lomake.loppu().value()]" [disabled]="!lomake().valid()">Tallenna</app-primary-button>
</mat-dialog-actions>
